import { notification } from 'antd';
import { BASE_URL } from '../conf/config';

/**
 * "Open Superset": a new tab, logged in to Superset as the ERP user (a one-use link from the backend), landing on
 * `next` (a path in Superset). The tab opens right away, before the link is there, so the browser doesn't
 * block it as a popup.
 */
export async function openSuperset(fetchWithAuth, next = '/dashboard/list/') {
  const tab = window.open('', '_blank');
  try {
    const response = await fetchWithAuth(`${BASE_URL}/api/superset/handoff/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ next }),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.errors?.[0] || 'Superset is not available right now.');
    if (tab) {
      tab.opener = null;
      tab.location.href = data.url;
    } else {
      window.location.href = data.url;
    }
  } catch (e) {
    if (tab) tab.close();
    notification.error({ message: 'Superset', description: e.message, duration: 6 });
  }
}
